<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      cell-class-name="align-top"
      resizable
      border="inner"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{ reserve: true, highlight: true, range: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @checkbox-range-change="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:sampleNameInfo="{ row }">
        <span>{{ row.devTrackingNo }}</span>
        <br />
        <span>{{ row.sampleName }}</span>
        <br />
        <span>{{ row.sampleNameEn }}</span>
      </template>
      <template v-slot:status="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="row.devTrackingStatus === 'Y' ? 'success' : 'danger'"
          >
            {{ row.v_devTrackingStatus }}
          </el-tag>
        </div></template
      >
      <template v-slot:devStatus="{ row }">
        <!-- <el-tag
          size="mini"
          :type="
            row.devStatus === 'A'
              ? ''
              : row.devStatus === 'B'
              ? 'warning'
              : row.devStatus === 'C'
              ? 'proofing'
              : row.devStatus === 'D'
              ? 'proofed'
              : row.devStatus === 'E'
              ? 'awaiting-send'
              : row.devStatus === 'F'
              ? 'danger'
              : row.devStatus === 'G'
              ? 'awaiting-testing'
              : row.devStatus === 'H'
              ? 'testing'
              : row.devStatus === 'I'
              ? 'tested'
              : row.devStatus === 'J'
              ? 'success'
              : ''
          "
        > -->
        {{ row.v_devStatus }}
        <!-- </el-tag> -->
      </template>
      <template v-slot:selectionFace="{ row }">
        <span>{{ row.proposalStyleNo }}</span>
        <br />
        <span>{{ row.sampleName }}</span>
      </template>

      <template v-slot:sampleSize="{ row }">
        <span
          >{{ $l('label_sample_size') || '尺寸' }}：{{ row.sampleSize }}</span
        >
      </template>
      <template v-slot:smcFtyPrice="{ row }">
        <span
          >{{ $l('label_cost_price') || '成本价格' }}：{{ row.ftyPrice }}
          {{ row.v_ftyCurrencyUnit }}</span
        >
        <br />
        <span>{{ row.sampleScmName }}</span>
      </template>

      <template v-slot:custName="{ row }">
        <span>{{ row.custName }}</span>
        <span v-if="row.endCustName">/{{ rwo.endCustName }}</span>
      </template>
      <template v-slot:selector="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>

      <template v-slot:originalSample="{ row }">
        <span>{{ row.proposalStyleNo }}</span>
        <br />
        <span>{{ row.originalSampleName }}</span>
        <br />
        <span>{{ row.originalSampleNameEn }}</span>
      </template>

      <template v-slot:categoryAndSize="{ row }">
        <span
          >{{ $l('label_category') || '品类' }}：{{ row.categoryName }}</span
        >
        <br />
        <span
          >{{ $l('label_sample_size') || '尺寸' }}：{{ row.sampleSize }}</span
        >
      </template>

      <template v-slot:modify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.openEditPage({
            pageType: menuType,
            params: { devTrackingCode: data.devTrackingCode },
            query: { devTrackingNo: data.devTrackingNo },
          })
          break
        case 'cancel':
          this.cancel(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'customerManage-selectionTracking-detail',
        params: { ...params, pageType },
        query,
      })
    },
    async cancel({ devTrackingCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_cancel_sample_selection'),
        this.$l('tips_confirmInfo'),
        {
          confirmButtonText: this.$l('btn_confirm'),
          cancelButtonText: this.$l('btn_cancel'),
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.loadingOpen()
      const res = await this.$api
        .masterCustomerTrackingDevDelApi({ devTrackingCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_cancel_no') || '取消失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_cancel_ok') || '取消成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      const $table = this.$refs.table
      $table.clearCheckboxRow()
      $table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (this.disabled) return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt', 'displayImage']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  // 已测试
  .el-tag--tested {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  // 测试中
  .el-tag--testing {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  // 待测试
  .el-tag--awaiting-testing {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  // 已打样
  .el-tag--proofed {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  // 打样中
  .el-tag--proofing {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
  // 待寄样
  .el-tag--awaiting-send {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }
}
</style>
